import "./DeleteModal.css";
import { Box } from "@mui/material";
import {
  PrimaryButton,
  SecondaryButton,
} from "../buttonComponent/ButtonComponent";
import ModalCloseButton from "./ModalCloseButton";
import StopIcon from "./img/agencySelector.svg";
import { useEffect, useState } from "react";
import Title from "../title/Title";
import Text from "../text/Text";
import Checkbox from "../checkbox/Checkbox";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 450,
  maxWidth: "90vw",
  bgcolor: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  p: 0,
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
};

const StopsArrayModal = ({
  selectedStop,
  isOpen,
  onClose,
  onConfirm,
  tripType,
  input,
}) => {
  const [localStop, setLocalStop] = useState(null);

  useEffect(() => {
    if (isOpen && selectedStop) {
      const originalStop = input.find((s) => s.id === selectedStop.id);
      if (!originalStop) return;
      const stopCopy = {
        ...originalStop,
        associatedChilds: originalStop.associatedChilds?.map((child) => ({
          ...child,
          selected: child.selected !== undefined ? child.selected : true,
        })),
      };
      const normalizedTrip = tripType?.toLowerCase();
      stopCopy.associatedChilds =
        stopCopy.associatedChilds?.filter((child) => {
          if (tripType?.toUpperCase() === "AM") return true;

          const matchingStops = child.associatedStop?.filter(
            (as) => as.stopId === stopCopy.id
          );

          if (!matchingStops || matchingStops.length === 0) return false;

          return matchingStops.some(
            (as) =>
              as.tripSession?.toLowerCase() === "none" ||
              as.tripSession?.toLowerCase() === normalizedTrip
          );
        }) || [];

      setLocalStop(stopCopy);
    }
  }, [selectedStop, isOpen, tripType]);

  const handleConfirm = () => {
    onConfirm(localStop);
  };

  const toggleChildSelection = (childId) => {
    setLocalStop((prev) => ({
      ...prev,
      associatedChilds: prev.associatedChilds.map((child) =>
        child.childId === childId
          ? { ...child, selected: !child.selected }
          : child
      ),
    }));
  };

  const noChildren =
    !localStop?.associatedChilds || localStop.associatedChilds.length === 0;

  if (!isOpen || !localStop) return null;

  return (
    <div className="modal-backdrop">
      <Box sx={style}>
        <div>
          <div className="modal-header-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img loading="lazy" src={StopIcon} alt="invite-users-icon" />
              <ModalCloseButton
                onClick={onClose}
                imgStyle={{ position: "relative", bottom: 0, left: 9 }}
              />
            </div>
          </div>

          <div
            style={{
              margin: "1rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
            }}
          >
            <Title
              title={localStop.name}
              titleSize="1.125rem"
              subtitleSize="0.875rem"
              subtitle={
                noChildren
                  ? "There are no students associated with this stop for this trip type."
                  : "Tick the students associated to this stop in this trip:"
              }
              gap="0rem"
              lineHeight="1.75rem"
            />

            {!noChildren && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  marginTop: "1.5rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "0.25rem",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Text
                      text="Name"
                      size="1rem"
                      weight="500"
                      color="#101828"
                    />
                  </div>
                  <div style={{ width: "100px", textAlign: "center" }}>
                    <Text
                      text="Selected"
                      size="1rem"
                      weight="500"
                      color="#101828"
                    />
                  </div>
                </div>

                {localStop.associatedChilds.map((child) => (
                  <div
                    key={child.childId}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0.5rem 0",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Text
                        text={`${child.firstName} ${child.lastName}`}
                        size="0.875rem"
                        weight="500"
                        color="#344054"
                      />
                    </div>

                    <div
                      style={{
                        width: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        value={child.childId}
                        checked={child.selected}
                        onClick={() => toggleChildSelection(child.childId)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div
            className="button-container-delete"
            style={{ marginTop: "1rem" }}
          >
            <SecondaryButton
              label="Cancel"
              width="190px"
              imageIcon={false}
              onClickFunction={onClose}
            />
            {!noChildren && (
              <PrimaryButton
                label="Confirm"
                width="190px"
                disable={false}
                onClickFunction={handleConfirm}
              />
            )}
          </div>
        </div>
      </Box>
    </div>
  );
};

export default StopsArrayModal;
